import { Component } from '@angular/core';
import { Toast } from 'ngx-toastr';

@Component({
    selector: 'app-cookie-consent-toast',
    templateUrl: './cookie-consent-toast.component.html',
    styleUrls: ['./cookie-consent-toast.component.scss']
})
export class CookieConsentToastComponent extends Toast {
    action(event: any) {
        event.stopPropagation();
        this.toastPackage.triggerAction(event);
        this.toastrService.clear();
        return false;
    }
}
